import styled from 'styled-components';

import { Card as GCard } from 'src/components';

export const Wrapper = styled.div`
  width: 100%;
  color: #666;
  margin-top: 10px;
  margin-bottom: 0;

  p {
    margin-bottom: 0;
  }

  .ant-row {
    flex-wrap: wrap;
  }

  .ant-col {
    margin-bottom: 8px;
  }

  @media (min-width: 992px) {
    .board-filters-row {
      flex-wrap: nowrap;
    }

    .ant-col {
      margin-bottom: 0;
      flex: 0 0 auto;
      max-width: none;
    }
  }

  @media (max-width: 767px) {
    .ant-typography {
      white-space: normal;
      word-break: break-word;
    }
  }
`;

export const Card = styled(GCard)`
  border-radius: 10px;

  .card-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
  }
`;
